import { gaAddToCart } from "@/utils/gaEvent";
import { criteoAddtoCart } from "@/utils/criteoEvent";
import { message } from "antd";
import viewcartApi from '@/service/modules/viewcartApi';
import { updateCarList } from "@/store/slices/cartListSlice";
import { AppDispatch } from "@/store/store";
import { useDispatch } from "react-redux";
import { matomoSetCustomDimension } from "./matomoEvent";

interface ParamsInterface {
  productID: string | number,
  qty: string | number,
  location?: string,
  position?: number,
  pages?: number,
  from?: 0 | 1
}

interface BatchParams {
  productList: Array<{ pid?: string | number, qty: string | number, productID?: string | number, from?: 0 | 1 }>,
  location?: string,
  position?: number,
  pages?: number,
  from?: 0 | 1
}

const useCartActions = () => {
  const dispatch: AppDispatch = useDispatch();

  const addToCart = async (event: any, parameter: ParamsInterface, callback?: Function) => {
    event.stopPropagation();
    const { productID, qty, from = 0 } = parameter;
    const params = { items: [{ pid: parseInt(`${productID}`), qty, from }] };
    await commonAddCart(params, parameter, dispatch, callback);
  }

  const batchAddToCart = async (event: any, parameter: BatchParams, callback?: Function) => {
    event.stopPropagation();
    const { productList, from = 0 } = parameter;
    const params = { items: productList.map((v:any)=> {return { pid: v.productID ?? v.pid, qty: v.qty || 1, from: v.from ?? from }}) };
    await commonAddCart(params, parameter, dispatch, callback);
  }

  return { addToCart, batchAddToCart };
}

const commonAddCart = async (params: any, queryData: any, dispatch: AppDispatch, callback?: Function,) => {
  try {
    const query = buildQuery(params.items, queryData);

    const res:any = await viewcartApi.addToCart(params, query);

    if (res.notice && res.notice.content) {
      message.warning(res.notice.content)
    }

    const shopCartData = await viewcartApi.getList();
    const { list: { available } } = shopCartData.data
    if(!available) {
      throw new Error("addCart error");
    }
    // 更新状态购物车数据
    dispatch(updateCarList(shopCartData));
    callback && callback(shopCartData);

    if (params.items.length === 1) {
      handleAnalytics(params.items[0].pid, available);
    }
  } catch (error: any) {
    message.error(error.message);
    callback && callback("error");
  }
}

const buildQuery = (items: any[], queryData: any) => {
  if (items.length === 1) {
    const { location, position, pages } = queryData;
    if (location && (position === 0 || position)) {
      return `?pid=${items[0].pid}&location=${location}&position=${position || 0}&page=${pages || 1}`;
    }
  }
  return "";
}

const handleAnalytics = (productID: string | number, available: any[]) => {
  if(available.length === 0) return console.log("no data")
  const goodsItem = available.find((v: any) => v.productID == productID);
  if(!goodsItem) return
  gaAddToCart("AUD", goodsItem.price, [{ ...goodsItem, quantity: 1 }]);

  matomoSetCustomDimension(28, JSON.stringify({ productID, quantity: 1 }))

  // const ScarabQueue: any = (window as any).ScarabQueue || [];
  // if (ScarabQueue) {
  //   const userEmail = localStorage.getItem('userEmail');
  //   if (userEmail) {
  //     ScarabQueue.push(['setEmail', userEmail]);
  //   }

  //   const scarabQueueCartData = available.map((item: any) => ({
  //     item: item.productID,
  //     price: Number(item.price),
  //     quantity: Number(item.quantity),
  //   }));

  //   ScarabQueue.push(['cart', scarabQueueCartData]);
  //   ScarabQueue.push(['go']);
  // }

  const criteoParams: any = {
    id: goodsItem.productID,
    price: goodsItem.price,
    quantity: 1,
  }
  criteoAddtoCart([criteoParams])

}

export default useCartActions;
